enum ProjectIntakeStatus {
  New = 0,
  InProgress = 1,
  AwaitingResponse = 2,
  Merged = 3,
  Deleted = 10
}

export default ProjectIntakeStatus;
